var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "failed-payment"
  }, [_c('h1', {
    staticClass: "failed-payment__title"
  }, [_vm._v(" Сожалеем, платеж не прошел! ")]), _c('p', {
    staticClass: "failed-payment__text"
  }, [_vm._v(" Пожалуйста, проверьте данные вашей карты. Возможно, карта просрочена или недостаточно средств. Попробуйте использовать другую карту для оплаты. ")]), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goToPayment
    }
  }, [_vm._v(" Перейти к оплате ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }